import { graphql, Link } from "gatsby";
import * as React from "react";

import { TheBakeryLanguages } from "../../../../company/settings/translations";
import { getSlugWithLang } from "../../modules/Shared/Utils/getSlugWithLang";
import { PropsTag } from "../../modules/TagList/Tag/Tag";
import TagsList from "../../modules/TagList/TagList";
import { ISliceProps } from "../../types/thecookies";

type ISliceListCategories = ISliceProps<Queries.CategoriesListQuery> & {
  render?: "list" | "tag";
};

const ListCategories: React.FC<ISliceListCategories> = (
  props: ISliceListCategories,
) => {
  const render = props?.render || "tag";
  const { language } = props.sliceContext;

  if (render === "list") {
    return (
      <ul>
        <li>
          <Link
            to={getSlugWithLang(TheBakeryLanguages[language].slug, language)}
            className="a-category-name"
          >
            TheBakery
          </Link>
        </li>
        {props.data.allSanityCategory.nodes.map((item, index) => {
          return (
            <li key={index}>
              <Link
                className="a-category-name"
                to={`${getSlugWithLang(
                  `/thebakery/${item?.slug}`,
                  props.sliceContext.language,
                )}`}
              >
                {item.name}
              </Link>
            </li>
          );
        })}
      </ul>
    );
  }

  const categoriesList: PropsTag[] = props.data.allSanityCategory.nodes.map(
    (item) => {
      return {
        tag: {
          name: item.title,
          slug: item.slug,
        },
        setting: {
          color: item.postList[0].color,
        },
      };
    },
  );
  return (
    <ul className={"m-categories-tags"}>
      <TagsList tagList={categoriesList} />
    </ul>
  );
};

export default ListCategories;

export const query = graphql`
  query CategoriesList($language: String!) {
    allSanityCategory(
      filter: {
        language: { eq: $language }
        postList: { elemMatch: { id: { ne: null } } }
      }
    ) {
      nodes {
        name
        alias
        title
        slug
        postList {
          color
        }
      }
    }
  }
`;
